<template>
  <div>
    <v-card flat>
      <v-card-title>
        <v-row align="center" no-gutters>
          <span class="title">En date du {{ getInventoryDate() }}</span>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row align="center" justify="space-between" no-gutters>
          <span v-if="getIsAdmin" class="subtitle-1"
            >Valeur totale: {{ getTotalValue }}$</span
          >
          <v-spacer v-else></v-spacer>
          <v-row class="no-print" align="center" justify="end" dense>
            <v-col cols="12" sm="6">
              <v-text-field
                dense
                filled
                hide-details
                single-line
                clearable
                prepend-inner-icon="fa-search"
                v-model="search"
                class="no-before"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-row>
        <InventoryRecordViewer
          v-if="date !== null"
          :template="template"
          :records="records"
          :search="search"
          manualRecords
          dense
        ></InventoryRecordViewer>
        <InventoryRecordViewer
          v-else
          :template="template"
          :search="search"
          dense
        ></InventoryRecordViewer>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
import moment from "moment";
import round10 from "round10";
import { InventoryRecordViewer } from "../components";
export default {
  name: "InventoryViewer",
  components: {
    InventoryRecordViewer
  },
  props: {
    date: {
      required: false,
      default: null
    }
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapGetters([
      "getInventoryTemplate",
      "getIsAdmin",
      "getInventoryTransactions",
      "getProducts"
    ]),
    getTotalValue() {
      return round10.round10(
        this.records
          .map(x => {
            const p = this.getProducts.find(pr => pr.id === x.fk_product);
            if (p && p.data) {
              const price = p.data.prix_inventory
                ? p.data.prix_inventory
                : p.data.prix;
              return round10.round10(x.quantity * price, -2);
            } else {
              return 0;
            }
          })
          .reduce((a, b) => a + b, 0),
        -2
      );
    }
  },
  data() {
    return {
      template: [],
      records: [],
      search: ""
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("startLoadingOverlay");
        if (this.date !== null) {
          this.records = await api.getInventoryRecords({
            store: this.getStoreId,
            date: this.date,
            latest: true
          });
        } else {
          this.records = this.$store.getters.getInventoryRecords;
        }
        await this.$store.dispatch("loadInventoryTemplates");
        this.template = [];
        if (this.getInventoryTemplate !== undefined) {
          this.template = this.getInventoryTemplate.templates;
        }
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    },
    getInventoryDate() {
      return this.date === null
        ? moment().format("lll")
        : moment(this.date).format("lll");
    }
  }
};
</script>

<style></style>
